import React, { useEffect, useState } from 'react';
import { checkDisplayValue } from 'src/utils';
import CitywiseClosingTable from './CityWiseReportTable';
import { getCityWiseClosingReport, filterCityWiseClosingReport } from '../_requests';
import axios from "axios";
import { KTCard, KTCardBody, KTSVG } from '../../../../_metronic/helpers';
import { configuration } from "src/configuration";
import {constants} from '../../../../utils/const'
import { useNavigate } from 'react-router-dom';

const API_URL = configuration.apiUrl;
const mockCityData = [
    { uuid: '1', city_name: 'City A', total_amount: 1000, check: false },
    { uuid: '2', city_name: 'City B', total_amount: 2000, check: false },
    { uuid: '3', city_name: 'City C', total_amount: 3000, check: false },
];
 
const CitywiseReportCity = () => {
    const [cityData, setCityData] = useState<any>([]);
    const [cityLoading, setCityLoading] = useState<any>(true);
    const [selectData, setSelectData] = useState<any>([]);
    const navigate = useNavigate();
    const [showButton, setShowButton] = useState<boolean>(false);
    const [filteredCreditData, setFilteredCreditData] = useState([]);
    const [filteredDebitData, setFilteredDebitData] = useState([]);
    const [filteredData, setFilteredData] = useState<{ [key: string]: { credit: any[], debit: any[] } }>({});
    const [exportLoading, setExportLoading] = useState<any>(false);
    const [exportType, setExportType] = useState<'pdf' | 'excel'>('pdf');
 
    const getCity = async () => {
        try {
            const response = await getCityWiseClosingReport();
            let cityList = { data: { responseData: response.responceData } };
            setCityData(cityList?.data?.responseData ?? []);
            setCityLoading(false);
        } catch (err) {
            setCityLoading(false);
            console.error("err", err);
        }
    };
 
    useEffect(() => {
        getCity();
    }, []);
 
    const showCheckBox = (id: any) => {
        if (id === "all") {
            let data = cityData.find((x: any) => !x.check);
            return data ? false : true;
        } else {
            let data = cityData.find((x: any) => x.id === id);
            return data?.check ? true : false;
        }
    };
 
    const handleCheckboxChange = async (id: any) => {
        try {
            let updatedCityData = cityData.map((city: any) => {
                if (city.id === id || city.uuid === id) {
                    return { ...city, check: !city.check };
                }
                return city;
            });
 
            setCityData(updatedCityData);
            setShowButton(updatedCityData.some((city: any) => city.check));
 
            const city = updatedCityData.find((c: any) => c.id === id || c.uuid === id);
            const isUnchecked = !city?.check;
 
            if (isUnchecked) {
                setFilteredData(prevState => {
                    const newState = { ...prevState };
                    delete newState[id];
                    return newState;
                });
                setSelectData((prev: any) => prev.filter((item: any) => item.id !== id));
                return;
            }
 
            const creditResponse = await axios.get(`${configuration.apiUrl}/city/postFilterCityWiseClosingReport?perPage=100000&page=1&search=&city_id=${id}&sort=party_code&order=asc&dr_cr=1`);
            const debitResponse = await axios.get(`${configuration.apiUrl}/city/postFilterCityWiseClosingReport?perPage=100000&page=1&search=&city_id=${id}&sort=party_code&order=asc&dr_cr=0`);
 
            const creditData = creditResponse?.data?.responceData?.data ?? [];
            const debitData = debitResponse?.data?.responceData?.data ?? [];
 
            setFilteredData(prevState => ({
                ...prevState,
                [id]: { credit: creditData, debit: debitData }
            }));
 
            // Update selectData immediately with city_name
            setSelectData((prev: any) => {
                const newSelectData = prev.filter((item: any) => item.id !== id); // Remove if already exists
                return [
                    ...newSelectData,
                    {
                        id,
                        city_name: city?.city_name || 'Unknown City',
                        credit: creditData,
                        debit: debitData
                    }
                ];
            });
        } catch (error) {
            console.error("Error fetching filtered city data:", error);
        }
    };
 
    const handleSelectAllChange = async () => {
        try {
            const allChecked = !showCheckBox("all");
            let updatedCityData = cityData.map((city: any) => ({
                ...city,
                check: allChecked,
            }));
            setCityData(updatedCityData);
            setShowButton(allChecked);
 
            if (!allChecked) {
                setFilteredData({});
                setSelectData([]);
                return;
            }
 
            const fetchPromises = updatedCityData.map(async (city: any) => {
                const cityId = city.id || city.uuid;
                const creditResponse = await axios.get(
                    `${configuration.apiUrl}/city/postFilterCityWiseClosingReport?perPage=100000&page=1&search=&city_id=${cityId}&sort=party_code&order=asc&dr_cr=1`
                );
                const debitResponse = await axios.get(
                    `${configuration.apiUrl}/city/postFilterCityWiseClosingReport?perPage=100000&page=1&search=&city_id=${cityId}&sort=party_code&order=asc&dr_cr=0`
                );
 
                return {
                    id: cityId,
                    city_name: city.city_name,
                    credit: creditResponse?.data?.responceData?.data ?? [],
                    debit: debitResponse?.data?.responceData?.data ?? []
                };
            });
 
            const results = await Promise.all(fetchPromises);
            setSelectData(results);
            setFilteredData(results.reduce((acc: any, result: any) => {
                acc[result.id] = { credit: result.credit, debit: result.debit };
                return acc;
            }, {}));
        } catch (error) {
            console.error("Error fetching data for all cities:", error);
        }
    };
 
    useEffect(() => {
        // Only sync selectData if filteredData has entries not in selectData
        const filteredIds = Object.keys(filteredData);
        const selectDataIds = selectData.map((item: any) => item.id);
        const missingIds = filteredIds.filter(id => !selectDataIds.includes(id));
 
        if (missingIds.length > 0) {
            const newSelectData = missingIds.map((id) => {
                const city = cityData.find((c: any) => c.id === id || c.uuid === id);
                if (!city) {
                    console.warn(`No city found for id: ${id}`, { cityData, filteredData });
                    return null;
                }
                return {
                    id,
                    city_name: city.city_name,
                    ...filteredData[id]
                };
            }).filter(item => item !== null);
 
            setSelectData((prev: any) => [
                ...prev.filter((item: any) => !missingIds.includes(item.id)),
                ...newSelectData
            ]);
        }
    }, [filteredData, cityData]);
    const showReport = () => {
        let data = cityData
            .filter((x: any) => x.check === true)
            .map((x: any) => ({
                id: x.id || x.uuid,
                city_name: x.city_name,
                credit: filteredData[x.id || x.uuid]?.credit || [],
                debit: filteredData[x.id || x.uuid]?.debit || []
            }));
        setSelectData(data);
    };
 
    const exportReport = async (type: 'pdf' | 'excel') => {
        try {
            setExportLoading(true);
            setExportType(type);

            const selectedCityIds = cityData
                .filter((city: any) => city.check)
                .map((city: any) => city.id || city.uuid)
                .join(",");

            if (!selectedCityIds) {
                console.warn("No cities selected for export.");
                setExportLoading(false);
                return;
            }

            // Construct query parameters based on export type
            const queryParams = new URLSearchParams({
                city_ids: selectedCityIds,
                ...(type === 'pdf' ? { isExport: 'true' } : { isExportExcel: 'true' })
            });

            const endpoint = `${API_URL}/city/exportCityWiseClosingReport?${queryParams.toString()}`;

            const response = await axios.get(endpoint, {
                responseType: "blob",
            });

            const fileType = type === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const fileName = type === 'pdf' ? 'Citywise_Report.pdf' : 'Citywise_Report.xlsx';

            const blob = new Blob([response.data], { type: fileType });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
            setTimeout(() => window.URL.revokeObjectURL(url), 1000);
            setExportLoading(false);
        } catch (err) {
            setExportLoading(false);
            console.error(`Error exporting ${type.toUpperCase()}:`, err);
        }
    };
 
    return (
        <div className="row">
            <div className="col-md-12">
                <div className="card">
                    <div className="card-header border-0 pt-6 align-items-center">
                        <h1 className="fs-5">Citywise Closing Balance</h1>
                        {/* <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button onClick={() => navigate(-1)} className="btn btn-secondary">
                ← Back
              </button>
              </div> */}
              
                        <div className="card-toolbar d-flex justify-content-end" style={{gap: '10px'}} >
                            {showButton && (
                                <div className="dropdown">
                                    <button
                                        type='button'
                                        className='btn btn-danger dropdown-toggle'
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                        disabled={exportLoading}
                                    >
                                        <span className='svg-icon svg-icon-2'>
                                            <KTSVG
                                                path='/media/icons/duotune/files/fil021.svg'
                                                className='svg-icon-1'
                                            />
                                        </span>
                                        {exportLoading ? 'Please Wait...' : 'EXPORT'}
                                    </button>
                                    <ul className="dropdown-menu">
                                        <li>
                                            <a 
                                                className="dropdown-item" 
                                                href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (!exportLoading) {
                                                        exportReport('pdf');
                                                        // Close the dropdown
                                                        const dropdown = document.querySelector('.dropdown-menu.show');
                                                        if (dropdown) {
                                                            const dropdownToggle = dropdown.previousElementSibling as HTMLElement;
                                                            if (dropdownToggle) {
                                                                dropdownToggle.click();
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                <i className="fa-solid fa-file-pdf me-2"></i>PDF
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                className="dropdown-item" 
                                                href="#" 
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (!exportLoading) {
                                                        exportReport('excel');
                                                        // Close the dropdown
                                                        const dropdown = document.querySelector('.dropdown-menu.show');
                                                        if (dropdown) {
                                                            const dropdownToggle = dropdown.previousElementSibling as HTMLElement;
                                                            if (dropdownToggle) {
                                                                dropdownToggle.click();
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                <i className="fa-solid fa-file-excel me-2"></i>Excel
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            )}
                            <div
                      className="btn btn-icon btn-shadow-lg  bg-primary text-white gap-4 border border-light"
                      style={{ zIndex: 99, width: "34px",
                        height: "32px"}}
                      role="button"
                      aria-label="Go back to previous page"
                      tabIndex={0}
                      data-tooltip="Back"
                      onClick={() => navigate(-1)}
                    >
                      <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
                    </div>
                        </div>
                    </div>
                    <div className="card-body py-4">
                        <div className='row'>
                            <div className='col-md-8 offset-md-2'>
                                <div className="table-responsive">
                                    <table className="city-listing table align-middle table-row-dashed fs-6 gy-5 table-striped">
                                        <thead>
                                            <tr className="text-start fw-bolder fs-6 text-uppercase gs-0">
                                                <th className="w-10px pe-2"></th>
                                                <th className="min-w-125px fw-bolder">Cities Name</th>
                                                <th className="min-w-125px"></th>
                                                <th className="d-flex justify-content-end pe-3">
                                                    <div className="form-check">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input primary-check"
                                                            checked={showCheckBox("all")}
                                                            onChange={handleSelectAllChange}
                                                            style={{cursor: 'pointer'}}
                                                        />
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="text-center">
                                            {cityLoading ? (
                                                <tr>
                                                    <td colSpan={4}>
                                                        <div className="d-flex text-center w-100 align-content-center justify-content-center fw-bolder">Loading...</div>
                                                    </td>
                                                </tr>
                                            ) : cityData.length > 0 ? (
                                                cityData.map((x: any) => (
                                                    <tr key={x.id}>
                                                        <td></td>
                                                        <td className="text-start fw-bolder">{checkDisplayValue(x.city_name)}</td>
                                                        <td className="fw-bolder">{constants.formatAmount(x.total_amount)}</td>
                                                        <td className="d-flex justify-content-end">
                                                            <div className="form-check">
                                                                <input
                                                                    type="checkbox"
                                                                    className="form-check-input primary-check"
                                                                    checked={showCheckBox(x.id)}
                                                                    onChange={() => handleCheckboxChange(x.id)}
                                                            style={{cursor: 'pointer'}}

                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4}>
                                                        <div className="d-flex text-center w-100 align-content-center justify-content-center fw-bolder">No matching records found</div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                                {/* <div className="py-4">
                                    {showButton && (
                                        <button onClick={showReport} className="btn btn-primary" style={{ width: "100%" }}>
                                            Find
                                        </button>
                                    )}
                                </div> */}
                            </div>
                        </div>
                        <div>
                            {selectData.map((x: any) => {
                                return (
                                    <CitywiseClosingTable
                                        key={x.id}
                                        data={x}
                                        city_name={x.city_name}
                                        filteredCreditData={filteredData[x.id]?.credit || []}
                                        filteredDebitData={filteredData[x.id]?.debit || []}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
 
export default CitywiseReportCity;
 